import type { Json } from "@/shared/types/database.types";

export const MARITAL_STATUS_LABELS = {
  married: "Married",
  single: "Single",
  divorced: "Divorced",
  widowed: "Widowed",
  domestic_partnership: "Domestic partnership",
  other: "Other",
} as const;

export type MaritalStatus = keyof typeof MARITAL_STATUS_LABELS;

const DEATH_CERTIFICATE_VALUES: Record<string, MaritalStatus> = {
  "married but separated": "married",
  "never married": "single",
};

function jsonField(json: Json | null, key: string): Json | undefined {
  return json && typeof json === "object" && !Array.isArray(json) ? json[key] : undefined;
}

export function toMaritalStatus(value: unknown): MaritalStatus | null {
  if (typeof value !== "string") return null;
  const key = value.trim().toLowerCase().replace(/\s+/g, "_");
  if (key in MARITAL_STATUS_LABELS) return key as MaritalStatus;
  return DEATH_CERTIFICATE_VALUES[key.replace(/_/g, " ")] ?? null;
}

export function maritalStatusLabel(value: unknown): string | null {
  const status = toMaritalStatus(value);
  return status ? MARITAL_STATUS_LABELS[status] : null;
}

/**
 * The legacy `estate_metadata.partnership` wins while it is set, because it holds the user's
 * own answer. Saving moves the answer into `marriage_info.status` and clears `partnership`.
 */
export function getMaritalStatus(estate: {
  estate_metadata: Json | null;
  marriage_info: Json | null;
}): MaritalStatus | null {
  return (
    toMaritalStatus(jsonField(estate.estate_metadata, "partnership")) ??
    toMaritalStatus(jsonField(estate.marriage_info, "status"))
  );
}

export function withMaritalStatus(marriageInfo: Json | null, status: MaritalStatus | null): Json {
  const current =
    marriageInfo && typeof marriageInfo === "object" && !Array.isArray(marriageInfo)
      ? marriageInfo
      : {};
  return { ...current, status };
}
